/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : CTAToStatsConverter.ts
*******************************************/

import { CTA_NAME, CTAStatsDetails, CTA_OUTCOME } from "../../stats/CTATypes.js";
import { SpecificEvaluatedAction } from "../EvaluatedAction.js";
import { EvaluationConverter } from "./EvaluationConverter.js";
import { LoginEvaluationConverter } from './converters/LoginEvaluationConverter.js';
import { AppProposalEvaluationConverter } from "./converters/AppProposalEvaluationConverter.js";
import { PersonalDataCompletionEvaluationConverter } from "./converters/PersonalDataCompletionEvaluationConverter.js";
import { SubscriptionEvaluationConverter } from "./converters/SubscriptionEvaluationConverter.js";

export class CTAToStatsConverter {
    converters: EvaluationConverter[] = [
        new LoginEvaluationConverter(),
        new AppProposalEvaluationConverter(),
        new PersonalDataCompletionEvaluationConverter(),
        new SubscriptionEvaluationConverter()
    ];

    ctaShown(action: SpecificEvaluatedAction): CTAStatsDetails {
        const det = this.toCTADetails(action);
        det.outcome = CTA_OUTCOME.SHOWN;
        det.source_element = "underfollow";
        return det;
    }

    ctaComplete(action: SpecificEvaluatedAction): CTAStatsDetails {
        const det = this.toCTADetails(action);
        det.outcome = CTA_OUTCOME.COMPLETED;
        det.source_element = "underfollow";
        return det;
    }

    ctaDismissed(action: SpecificEvaluatedAction): CTAStatsDetails {
        const det = this.toCTADetails(action);
        det.outcome = CTA_OUTCOME.DISMISSED;
        det.source_element = "underfollow";
        return det;
    }

    public toCTADetails(action: SpecificEvaluatedAction): CTAStatsDetails {
        const converter = this.converters.filter(conv => conv.check(action)).shift();
        if (converter) {
            return converter.convert(action);
        }
        else {
            return null;
        }
    }

}